// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1sD4B","tab":"Tabs_tab__oOYCn","tabActive":"Tabs_tabActive__2Rx6o"};